type DataType = {
  url: string;
  fields: Record<string, string>;
};
export const uploadFile = async (
  data: DataType,
  file: Blob,
  options: { signal?: AbortSignal } = {},
) => {
  const formData = new FormData();
  Object.entries({ ...data.fields, file }).forEach(([key, value]) => {
    formData.append(key, value as string | Blob);
  });

  return await fetch(data.url, {
    method: "POST",
    body: formData,
    signal: options.signal,
  });
};
